// extracted by mini-css-extract-plugin
export default {"appShell":"protected-layout_appShell__ARxeB","contentWrap":"protected-layout_contentWrap__vYo1d"};